import BsButton from './index.vue'
export default BsButton